import { render, staticRenderFns } from "./ManterPerfisView.vue?vue&type=template&id=52889b0e&scoped=true"
import script from "./ManterPerfisView.vue?vue&type=script&lang=js"
export * from "./ManterPerfisView.vue?vue&type=script&lang=js"
import style0 from "./ManterPerfisView.vue?vue&type=style&index=0&id=52889b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52889b0e",
  null
  
)

export default component.exports